// extracted by mini-css-extract-plugin
export default {"content":"page-content_content__CkZhD","contentWrapper":"page-content_contentWrapper__J4rVG","contentWrapperDesktop":"page-content_contentWrapperDesktop__VA3zZ"};